import { useEffect, useState } from "react";
import axios from "axios";
import { formatTimestamp } from "../utils/timestampUtils";

export const useS3ObjectLastModified = (
  url?: string | null
): { lastModified: string; loading: boolean } => {
  const [lastModified, setLastModified] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!url) {
      setLastModified("");

      setLoading(false);

      return;
    }

    setLoading(true);

    axios
      .get(url, { headers: { Range: "bytes=0-0" } }) // s3 signed url is GET only. Limit data since only header needed.
      .then(response => {
        const lm = response.headers["last-modified"];

        if (lm) {
          setLastModified(formatTimestamp(lm));
        } else {
          setLastModified("");
        }
      })
      .catch(() => {
        setLastModified("");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [url]);

  return { lastModified, loading };
};
